const region = process.env.AWS_REGION;
const assistDomainApiId = typeof process.env.ASSIST_DOMAIN_REST_API_ID !== 'undefined' ? process.env.ASSIST_DOMAIN_REST_API_ID : 'i829txajde';
let activeAccount = typeof process.env.MARLEY_ACTIVE_ACCOUNT !== 'undefined' ? process.env.MARLEY_ACTIVE_ACCOUNT : 'dev';

// workaround which deals with the inconsistency between assist / workflow domain and the rest of the product
if (activeAccount === 'production') {
  activeAccount = 'prod';
}

export const ASSIST_BASE_URL = `https://${assistDomainApiId}.execute-api.${region}.amazonaws.com/${activeAccount}/`;

export const QUERY_KEYS = {
  CASES: 'joblist',
  PINNED_CASES: 'pinnedCases',
  GROUPS: 'groups',
  USERS: 'users',
  SUBGROUP: 'subgroup',
  OPERATORS: 'operators',
};
